// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeRange_root__22alL","bookingInfo":"TimeRange_bookingInfo__TcHnI","dateSection":"TimeRange_dateSection__1J-cy"};